import { render, staticRenderFns } from "./DigitalTwin.vue?vue&type=template&id=20e0c6f2&"
import script from "./DigitalTwin.vue?vue&type=script&lang=js&"
export * from "./DigitalTwin.vue?vue&type=script&lang=js&"
import style0 from "./DigitalTwin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports